// AdSense configuration loaded from environment variables
const ADSENSE_PUBLISHER_ID = "ca-pub-1082506802303284";

// AdSense configuration loaded from environment variables
export const ADSENSE_PUBLISHER_ID_TEST = "ca-pub-3940256099942544";

export const RESPONSIVTE_SLOT_TEST = "6300978111";

// Map of slot keys to slot IDs
export const slotMap = {
  '728_90_Responsive': "1309600248",
  '728_90_ActivityList': "9342436266",
  '728_90_TimelineEntry': "7963514216",
  '350_552_Fixed': "6043407396",
  '350_250_Responsive': "3770760986",
  '350_552_Responsive_TimelineEntry': "8752684412",
  '350_250_Responsive_ActivityList': "8752684412",
};


export function isProduction() {
  let isProdFlag = false;
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const localFlag = window.localStorage.getItem('isProduction');
      if (localFlag === 'true') {
        isProdFlag = true;
      }
    }
  } catch (e) {
    // Ignore localStorage errors
  }
  console.log('isProduction',"isProdFlag", isProdFlag);
  const hostname = (typeof window !== 'undefined' ? window.location.hostname : '');
  return isProdFlag || hostname === 'app.checkmytrip.com' || hostname === 'uat.checkmytrip.com' || hostname === 'test.checkmytrip.com';
}

// Utility to get correct AdSense publisher and slot based on environment
export function getAdSenseConfig(key: keyof typeof slotMap) {
  return {
    publisherId: isProduction() ? ADSENSE_PUBLISHER_ID : ADSENSE_PUBLISHER_ID_TEST,
    slotId: slotMap[key] || "3770760986",
  };
}